export enum ErrorBusinessCode {
  OTP_SIGNATURE_FAILED = '113'
}
